import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { GameTicket } from '@app/@shared/models/game.model';
import { WalletType } from '@app/@shared/models/wallet-type.model';
import { Wallet } from '@app/@shared/models/wallet.model';
import { WalletApiService } from '@app/@shared/services/wallet-api.service';
import { ModalController, ToastController } from '@ionic/angular';
import { LoadingController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-recharge-payment',
  templateUrl: './recharge-payment.component.html',
  styleUrl: './recharge-payment.component.scss',
})
export class RechargePaymentComponent implements OnInit {
  balance = 0;
  amount = 0;

  wallet!: Wallet;
  walletType!: WalletType;
  commission = 0;

  tickets: GameTicket[] = [];

  recharge = 0;
  step = 0;
  transaction = '';
  userTokenId = '';

  transactionIdentifier = '';

  walletApiS!: WalletApiService;

  paymentForm?: FormGroup;
  currentYear = 0;

  constructor(
    private modalCtrl: ModalController,
    private loadingCtrl: LoadingController,
    private toastCtrl: ToastController,
    private fb: FormBuilder,
    private translateS: TranslateService
  ) {}

  ngOnInit(): void {
    this.paymentForm = this.fb.group({
      cardNumber: ['', [Validators.required, Validators.pattern('^[0-9]{13,19}$')]],
      expirationMonth: ['', [Validators.required, Validators.min(1), Validators.max(12)]],
      expirationYear: ['', [Validators.required, Validators.min(this.currentYear)]],
      cvv: ['', [Validators.required, Validators.minLength(3), Validators.maxLength(4)]],
    });

    const commission = this.walletType.commissions.find((c) => c.operationType === 'recharge');
    if (commission) {
      this.commission = commission.value / 100;
    }
  }

  changeQuantity(n: number) {
    this.recharge = n;
    if (!this.commission) {
      const commission = this.walletType.commissions.find((c) => c.operationType === 'recharge');
      if (commission) {
        this.commission = commission.value / 100;
      }
    }
  }

  close() {
    this.modalCtrl.dismiss(null, 'close');
  }

  next() {
    this.step ? this.onSubmit() : this.prepareRecharge();
  }

  async prepareRecharge() {
    const loading = await this.loadingCtrl.create({
      message: this.translateS.instant('loading'),
    });

    await loading.present();

    //console.log({  w: this.wallet,});

    const response = await this.walletApiS.initiateWalletRechargeUser({
      walletId: this.wallet.id,
      amount: this.recharge,
    });

    if (response) {
      const transaction = response.transactionId;
      if (transaction) {
        this.transaction = transaction;
        this.step = 1;

        await loading.dismiss();
        return;
      }
    }

    await loading.dismiss();

    const toast = await this.toastCtrl.create({
      message: this.translateS.instant('error.payment.initialite-recharge'),
      duration: 3000,
      buttons: [
        {
          icon: 'close',
        },
      ],
    });

    await toast.present();
  }

  async onSubmit() {
    const loading = await this.loadingCtrl.create({
      message: this.translateS.instant('loading'),
    });

    await loading.present();

    await loading.dismiss();
  }

  getRandom(min: number, max: number) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }
}
